/** @jsxImportSource react */
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { formatNumber } from '../../utils/numbers'

/** A summary report's rows with a totals line; repeated group labels are shown once. */
const ReportTable = ({ result }) => {
  if (!result) return null
  const groups = result.columns.filter((c) => !c.measure).length
  const measures = result.columns.filter((c) => c.measure)
  return (
    <TableContainer sx={{ maxHeight: 560 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            {result.columns.map((c, i) => (
              <TableCell key={i} align={c.measure ? 'right' : 'left'} sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}>{c.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {result.rows.map((row, r) => (
            <TableRow key={r} hover>
              {row.groups.map((g, i) => {
                const prev = result.rows[r - 1]
                const repeat = i < groups - 1 && prev && prev.groups.slice(0, i + 1).every((x, j) => x.value === row.groups[j].value)
                return (
                  <TableCell key={i} sx={{ color: g.value === null ? 'text.secondary' : 'text.primary', borderBottomColor: repeat ? 'transparent' : undefined }}>
                    {repeat ? '' : g.label}
                  </TableCell>
                )
              })}
              {row.values.map((v, i) => (
                <TableCell key={i} align="right" sx={{ fontVariantNumeric: 'tabular-nums' }}>{formatNumber(v, measures[i]?.fieldType)}</TableCell>
              ))}
            </TableRow>
          ))}
          <TableRow>
            {Array.from({ length: groups }, (_, i) => (
              <TableCell key={i} sx={{ fontWeight: 600, borderTop: 2, borderColor: 'divider' }}>{i === 0 ? 'Total' : ''}</TableCell>
            ))}
            {result.totals.map((v, i) => (
              <TableCell key={i} align="right" sx={{ fontWeight: 600, borderTop: 2, borderColor: 'divider', fontVariantNumeric: 'tabular-nums' }}>
                {formatNumber(v, measures[i]?.fieldType)}
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
      {result.truncated && (
        <Box sx={{ p: 1 }}><Typography variant="caption" color="text.secondary">Showing the first 500 groups; add a filter to narrow it.</Typography></Box>
      )}
    </TableContainer>
  )
}

export default ReportTable
